import { ViewContainerRef } from '@angular/core';
import { Field } from './field';
/**
 * @abstract
 */
export abstract class FieldWrapper extends Field {
  fieldComponent: ViewContainerRef;
}

function FieldWrapper_tsickle_Closure_declarations() {
/** @type {?} */
FieldWrapper.prototype.fieldComponent;
}

